import { useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Field } from '~/components/shared/Field';
import { UPSERT_BUSINESS } from '~/services/onboarding';
import { StepComponentProps } from '../types';

export const CreateBusiness = ({
  business,
  moveNextStep,
  setDisable,
  submitForm,
  setSubmitForm,
}: StepComponentProps) => {
  const { t } = useTranslation('onboarding');
  const [upserBusiness] = useMutation(UPSERT_BUSINESS, {
    onCompleted: (data) => {
      if (data.response.hasError) {
        console.error(data.response.message);
        setSubmitForm(false);
      } else {
        moveNextStep(data.response.data);
      }
    },
    onError: (error) => {
      console.error(error);
      setSubmitForm(false);
    },
  });

  const { register, setValue, watch, getValues } = useForm({
    defaultValues: {
      business_id: business?._id || '',
      business_name: business?.business_name || '',
      agent_name: business?.agent_name || '',
      agent_type: business?.agent_type || '',
    },
  });

  useEffect(() => {
    if (submitForm) {
      const data = getValues();
      upserBusiness({
        variables: {
          input: {
            ...data,
          },
        },
      });
    }
  }, [submitForm]);

  useEffect(() => {
    if (business.business_name && business.agent_name && business.agent_type) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, []);

  const watchedFields = watch(['business_name', 'agent_name', 'agent_type']);

  useEffect(() => {
    const allFilled = watchedFields.every(
      (field) => field && field.trim() !== '',
    );
    setDisable(!allFilled);
  }, [watchedFields]);

  return (
    <div className="flex flex-col gap-4">
      <h1 className="mb-4 text-3xl font-bold">{t('create_agent.title')}</h1>
      <p className="text-sm font-bold">{t('create_agent.agent_type')}</p>
      <div className="flex flex-row gap-4">
        <button
          className={`btn flex h-fit w-fit flex-col gap-2 p-2 md:flex-row ${
            watch('agent_type') === 'ECOMMERCE' ? 'bg-green-200' : ''
          }`}
          onClick={() => setValue('agent_type', 'ECOMMERCE')}
        >
          <span className="text-xl">🏪</span>
          {t('create_agent.ecommerce')}
        </button>
        <button
          className={`btn flex h-fit w-fit flex-col gap-2 p-2 md:flex-row ${
            watch('agent_type') === 'SUPPORT' ? 'bg-green-200' : ''
          }`}
          onClick={() => setValue('agent_type', 'SUPPORT')}
        >
          <span className="text-xl">👩‍💻</span>
          {t('create_agent.support')}
        </button>
      </div>
      <Field
        register={register}
        label={t('create_agent.business_name')}
        fieldName="business_name"
        placeholder={t('create_agent.business_name_placeholder')}
      />
      <Field
        register={register}
        label={t('create_agent.agent_name')}
        fieldName="agent_name"
        placeholder={t('create_agent.agent_name_placeholder')}
      />
    </div>
  );
};
